/* eslint-disable camelcase */
// import axios from 'axios';
import {axios} from '../axios'
import { baseEnvironment } from '../environment/environment.base';
import {ResponseData,ConfigurationItem,updateResponseData} from './service-mappers/BaseMapper';


const v1Version = baseEnvironment.apiVersion1;
const surgeryInductionAnestheticAgentsRoute = `${v1Version}${baseEnvironment.apiEndPoints.surgeryInductionAnestheticAgents.induction}`;
const surgeryAnestheticInfusion = `${v1Version}${baseEnvironment.apiEndPoints.anestheticInfusion.anestheticInfusion}`;
const anestheticInfusionUpdate =  `${v1Version}${baseEnvironment.apiEndPoints.anestheticInfusionUpdate.anestheticInfusionUpdate}`;
const anestheticSedative = `${v1Version}/${baseEnvironment.apiEndPoints.anestheticSedativeBolusList.sedativeBolusList}`;
const narcotic = `${v1Version}/${baseEnvironment.apiEndPoints.anestheticNarcotics.narcoticsList}`;
const concentrationList = `${v1Version}/${baseEnvironment.apiEndPoints.concentration.concentrationRates}`;

/* Find surgeryIndutionAnestheticAgnents*/
export const getSurgeryInductionAnestheticAgents = async (
  id: any,
  reqObject:any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryInductionAnestheticAgentsRoute + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

/* Find surgeryAnestheticsAgenst*/
export const getSurgeryAnestheticsInfusion = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryAnestheticInfusion + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

/* Find surgeryAnestheticsInfusionWithTimeStamp*/
export const getSurgeryAnestheticsInfusionWithTimeStamp = async (
  id: any,
  time_stamp: any
): Promise<any> => {
  try {
    const response = await axios.get(
      surgeryAnestheticInfusion + `/` + id + '/' + time_stamp
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const updateAnestheticsInfusionTimeStamp = async (
  id: any,
  time_stamp: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      anestheticInfusionUpdate + `/` + id + '/' + time_stamp,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getAnestheticSedativeList = async (): Promise<ResponseData<ConfigurationItem[]>> => {
  const response = await axios.get(`/${anestheticSedative}`);
  return response.data; // returning only the data from the response
};

export const updateAnestheticSedativeList = async (
  changedList: any,
  deletedIds: any
): Promise<updateResponseData> => {
  const response = await axios.post(`/${anestheticSedative}`, {
    changedList,
    deletedIds
  });
  return response.data;
};

export const getAnestheticNarcoticsList = async (): Promise<ResponseData<ConfigurationItem[]>> => {
  const response = await axios.get(`/${narcotic}`);
  return response.data; // returning only the data from the response
};

export const updateAnestheticNarcoticsList = async (
  changedList: any,
  deletedIds: any
): Promise<updateResponseData> => {
  const response = await axios.post(`/${narcotic}`, {
    changedList,
    deletedIds
  });
  return response.data;
};

export const getInfusionConcentrationList = async (): Promise<ResponseData<ConfigurationItem[]>> => {
  const response = await axios.get(`/${concentrationList}`);
  return response.data;
}
